import "@babel/polyfill";
import "./css/style.scss";
import "./css/aGlobalDesign.scss";
import "react-toastify/dist/ReactToastify.css";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
// import "bootstrap";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { history } from "./src/history";

import configureStore from "./configureStore";
import * as RoutesModule from "./routes";
const routes = RoutesModule.routes;
import ErrorBoundary from "./components/ErrorBoundary";

const initialState = {
    currentuser: {
        user: null,
        currentorganization: null,
        usergroups: null,
        accessrights: null
    },
    communication: {
        webRTConnection: null,
        linkedPortalAgent: undefined,
        callSession: null
    },
    contents: {
        playlist: null,
        playlistAccessLevel: 0,
        contents: null,
        videomessages: null,
        secondarycontents: null,
        storageSpace: null,
        storage: null,
        compositions: null,
        secondarycompositions: null,
        playlists: null,
        secondaryplaylists: null,
        schedules: null,
        styles: null,
        secondarystyles: null,
        uploadProgress: 0
    },
    deployment: {
        waitingDeploymentCount: null,
        deploymentslist: null,
        isDeploying: false
    },
    dictionaries: {
        accessLevels: null,
        contentTypes: null,
        displayTypes: null,
        transitions: null,
        timezones: null,
        fonts: null,
        tags: null
    },
    monitoring: {
        disconnectedcount: null,
        displaygroups: null,
        secondarydisplaygroups: null,
        callcenters: null,
        secondarycallcenters: null,
        freecalllinks: null,
        recalllinks: null,
        callapps: null,
        decisiontrees: null,
        portalagents: null,
        secondaryportalagents: null,
        displays: null,
        secondarydisplays: null,
        display: null,
        log: null,
        dashboardzoneId: null,
        calllogszoneId: null
    },
    administration: {
        invitationscount: null,
        videomessagesNotBeenSeencount: null,
        contentgroups: null,
        secondarycontentgroups: null,
        users: null,
        secondaryusers: null,
        invitations: null,
        usergroups: null,
        secondaryusergroups: null,
        zones: null,
        secondaryzones: null,
        callcategories: null
    },
    home: {
        appBarTitle: "",
        language: "fr",
        isDrawerOpen: true,
        AdministrationMenuOpen: false,
        MonitoringMenuOpen: false,
        DeploymentMenuOpen: false,
        DataMenuOpen: false,
        SecurityMenuOpen: false,
        CreationMenuOpen: true,
        OrganisationMenuOpen: false,
        SystemAdministratorMenuOpen: false,
        currentMenuName: ""
    },
    alertDialog: {
        isOpen: false,
        title: "",
        boldText: "",
        description: "",
        hideClose: false,
        primaryLabel: "",
        secondaryLabel: "",
        textFieldLabel: null,
        onPrimaryAction: () => {},
        onSecondaryAction: () => {},
        clickOutsideToClose: true
    },
    configuration: null,
    styles: {
        list: null,
        item: null
    },
    superAdmin: {
        errorReport: {
            list: null,
            item: null
        },
        organization: {
            list: null
        }
    },
    uploadManager: {
        isOpen: false,
        isUploading: false,
        queue: [],
        inProgress: [],
        done: [],
        progress: null
    },
    dataSources: {
        forms: null,
        secondaryforms: null
    }
};

// Get the application-wide store instance, prepopulating with state from the server where available.

export const store = configureStore(initialState);


const renderApp = () => {
    const container = document.getElementById("root");
    const root = createRoot(container);
    root.render(
        <ErrorBoundary>
            <Provider store={ store }>
                <Router history={history}>
                    {routes}
                </Router>
            </Provider>
        </ErrorBoundary>
    );
};

renderApp();
